import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment.local';

@Component({
    selector: 'loading-creating-site',
    templateUrl: './loading-creating-site.component.html',
    styleUrls: ['./loading-creating-site.component.scss'],
})
export class LoadingCreatingSiteComponent implements OnChanges {
    steps: string[] = [];
    currentStep = 0;
    progress = 0;
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
    finished = false;
    @Input() regenerate = false;

    constructor(private translate: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['regenerate']) {
            this.buildSteps();
        }
    }

    private buildSteps(): void {
        if (!this.regenerate) {
            this.steps = [
                this.translate.instant('app.wizard.stepper_ia.loader.best-design'),
                this.translate.instant('app.wizard.stepper_ia.loader.creating-pages'),
                this.translate.instant('app.wizard.stepper_ia.loader.applying-colors'),
                this.translate.instant('app.wizard.stepper_ia.loader.rendering'),
                this.translate.instant('app.wizard.stepper_ia.loader.ordering'),
            ];
        } else {
            this.steps = [
                this.translate.instant('app.wizard.stepper_ia.regenerate-loader.interpratando-ajustes'),
                this.translate.instant('app.wizard.stepper_ia.regenerate-loader.buscando-diseno'),
                this.translate.instant('app.wizard.stepper_ia.regenerate-loader.re-generando-paginas'),
                this.translate.instant('app.wizard.stepper_ia.regenerate-loader.finalizando-propuesta'),
            ];
        }
    }

    ngOnInit(): void {
        this.animateSteps();
    }

    get loadingImage(): string {
        const basePath = `${this.assetsUrl}${this.mfsPath}/img/front/wizard/sections/`;

        return this.regenerate ? `${basePath}Loading-regenerar-sitio.svg` : `${basePath}Loading-sitio.svg`;
    }

    animateSteps(): void {
        const stepDuration = 1500;
        const totalSteps = this.steps.length;

        for (let i = 0; i < totalSteps; i++) {
            setTimeout(() => {
                this.currentStep = i + 1;
                this.progress = ((i + 1) / totalSteps) * 80;
            }, stepDuration * i);
        }

        setTimeout(() => {
            this.progress = 80;
        }, stepDuration * totalSteps);
    }

    animateStepsRegenerate(): void {
        const stepDuration = 2000;
        const totalSteps = this.steps.length;

        for (let i = 0; i < totalSteps; i++) {
            setTimeout(() => {
                this.currentStep = i + 1;
                this.progress = ((i + 1) / totalSteps) * 80;
            }, stepDuration * i);
        }

        setTimeout(() => {
            this.progress = 80;
        }, stepDuration * totalSteps);
    }
}
